import React from 'react'
import PropTypes from "prop-types"
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { concat, uniq, get, sortBy } from 'lodash'
import queryString from 'query-string'
import DocumentTitle from "react-document-title"
import { Modal, FormGroup, Panel, FormControl } from 'react-bootstrap'

import { createProduct, removeProduct, updateProduct } from '../ducks/products'
import AdminNav from '../components/AdminNav.jsx'
import { docListStyle } from '../containers/PageStyles'
import Button from '../components/Button.jsx'
import { getText } from '../lib/text.js'
import CitySelector from '../cities/CitySelector.jsx'
import AddProduct from './AddProduct.jsx'
import postResetZSX from "./resetZSX"
import { updateCity } from '../ducks/cities'
import ProductsList from "./ProductsPage.List.jsx"

import {
  getProductTags, getFromQuery, getProducts,
  getCitiesWithProducts, getCities, getOrganizedProducts
} from '../selectors'

import "./ProductsPage.less"

/**
 *
 */

class ProductsPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      modal: null, // null|"edit"|"files"|"create"
      productModal: null,
      selectedCity: "Madrid",
      selectedCities: [],
      collapsed: false
    }
  }

  handleProductCreate() {
    const n = prompt(getText("Nombre"))
    if (n) this.props.onProductCreate(n, id => console.log(id)/* this.open(id) */)
  }

  open(id) {
    const back = browserHistory.getCurrentLocation().pathname + browserHistory.getCurrentLocation().search
    browserHistory.push(`/private/product/${encodeURIComponent(id)}?${queryString.stringify({ back })}`)
  }

  remove(id) {
    this.props.remove(id)
  }

  render() {
    // I add a calculated field, activitiesNumber, to each item in the list
    // i need it to be a string bc sort function uses localCompare
    const list = uniq(concat(this.props.citiesWithProducts, this.state.selectedCities))

    return (
      <div style={docListStyle()} className="products-page">
        <DocumentTitle title= {`Tripmaker ${getText("Productos")}`} />
        <AdminNav active="products" />

        <div className="toolbar">
          <Button
            onClick={() => this.setState({ modal: "create" })}
            glyph="plus"
          >
            {getText("Añadir ciudad")}
          </Button>
          <Button
            onClick={postResetZSX}
            glyph="refresh"
          >
            {getText("Refrescar ZXS")}
          </Button>
          <Button
            onClick={() => this.setState({ collapsed: !this.state.collapsed })}
            glyph={this.state.collapsed ? "resize-full" : "resize-small"}
          >
            {getText(this.state.collapsed ? "Expandir" : "Plegar")}
          </Button>
        </div>
        {
          sortBy(list, city => get(this.props.cities, [city, "zsxOrder"], Infinity))
            .map(city => (
              <Panel bsStyle="primary" key={city}>
                <Panel.Heading className="city-heading">
                  <Panel.Title>{get(this.props.cities, [city, "name"], "")}</Panel.Title>
                  <div className="order">
                    <label>Orden</label>
                    <FormControl
                      type="number"
                      style={{ width: 75 }}
                      onChange={evt => this.props.onCityChange(city, { zsxOrder: parseInt(evt.target.value) })}
                      value={get(this.props.cities, [city, "zsxOrder"], Infinity)}
                    />
                  </div>
                </Panel.Heading>
                {
                  !this.state.collapsed && (
                    <Panel.Body className="city-panel-body">
                      {
                        [
                          ["restaurant", "success"],
                          ["other", "info"],
                        ]
                          .map(([type, bsStyle]) => (
                            <ProductsList
                              key={type}
                              type={type}
                              city={city}
                              bsStyle={bsStyle}
                              onChange={this.props.onChange}
                              organizedProducts={this.props.organizedProducts}
                              tags={this.props.tags}
                              onAdd={() => this.setState({ productModal: { type, city } })}
                            />
                          ))
                      }
                    </Panel.Body>
                  )
                }
              </Panel>
            ))
        }
        {
          this.state.modal == "create" && (
            <Modal
              show
              onHide={() => this.setState({ modal: null })}
            >
              <Modal.Header>
                <Modal.Title>
                  {getText("Añadir ciudad")}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <FormGroup>
                  <CitySelector
                    inline
                    cityId={this.state.selectedCity}
                    onChange={originCity => this.setState({ selectedCity: originCity })}
                    countryLabel={getText("País de origen")}
                    cityLabel={getText("Ciudad de origen")}
                  />
                </FormGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({ modal: null })}>
                  {getText("Cancelar")}
                </Button>
                <Button
                  disabled={!this.state.selectedCity}
                  bsStyle="success"
                  onClick={() => this.setState(prevState => ({
                    selectedCities: [...prevState.selectedCities, prevState.selectedCity],
                    modal: null
                  }))}
                >
                  {getText("Añadir")}
                </Button>
              </Modal.Footer>
            </Modal>
          )
        }
        {
          this.state.productModal && (
            <AddProduct
              type={this.state.productModal.type}
              city={this.state.productModal.city}
              onClose={() => this.setState({ productModal: null })}
              onCreate={(name, type, city) => {
                this.props.onProductCreate({ name, tags: type == "restaurant" ? { "2sn6dbecc3": true } : {}, city })
                this.setState({ productModal: null })
              }}
            />
          )
        }
      </div>
    )
  }
}

ProductsPage.propTypes = {
  cities: PropTypes.object.isRequired,
  citiesWithProducts: PropTypes.arrayOf(PropTypes.object).isRequired,
  products: PropTypes.object.isRequired,
  organizedProducts: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired, // (string, object) => void
  onCityChange: PropTypes.func.isRequired, // (string, object) => void
  onProductCreate: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  query: PropTypes.shape({
    search: PropTypes.string,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.oneOf([ "ASC", "DESC" ]).isRequired
  }).isRequired,
  tags: PropTypes.object.isRequred, // { [string]: object }
}

const mapStateToProps = (state, ownProps) => ({
  products: getProducts(state, ownProps),
  organizedProducts: getOrganizedProducts(state, ownProps),
  cities: getCities(state, ownProps),
  citiesWithProducts: getCitiesWithProducts(state, ownProps),
  query: {
    search: getFromQuery(state, ownProps)("search") || "",
    sortDirection: getFromQuery(state, ownProps)("sortDirection") || "ASC",
    sortColumn: getFromQuery(state, ownProps)("sortColumn") || "name"
  },
  tags: getProductTags(state, ownProps)
})

const mapDispatchToProps = (dispatch) => ({
  onChange: (id, changes) => dispatch(updateProduct(id, changes)),
  onCityChange: (id, changes) => dispatch(updateCity(id, changes)),
  onProductCreate: ({ name, tags, city }) => dispatch(createProduct({ name, tags, city })),
  remove: id => dispatch(removeProduct(id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage)
